import React from 'react';
import { Card, CardHeader, CardTitle, CardBody, Row, Col, Button } from 'reactstrap';
import YouTubeEmbed from 'components/YouTubeEmbed';
import { useHistory } from 'react-router-dom';

function Autorizaciones() {
  const history = useHistory();

  return (
    <div className='content'>
      <Row>
        <Col>
          <Card className='card-user'>
            <CardHeader>
              <Row>
                <Col sm={8}>
                  <CardTitle tag='h4'>Ayuda</CardTitle>
                </Col>
                <Col sm={4} className="text-right">
                  <Button
                    className="btn-round"
                    color="primary"
                    onClick={() => history.push('/solicitudes')}
                  >
                    Volver
                  </Button>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Row className="pt-4 pb-4">
                <Col sm={6}>
                  <h5>Gestión de Autorización Presenciales</h5>
                  <div className="mb-4 font-weight-bold">
                    <a
                      href="/pdf/manual_Gestión de Autorización presenciales.pdf"
                      target="_blank"
                      rel="noopener noreferrer">Ver Manual</a>
                  </div>
                </Col>
                <Col sm={6}>
                  <h5>Gestión de Autorización OSPe</h5>
                  <div className="mb-4 font-weight-bold">
                    <a href="/pdf/manual_ospe.pdf" target="_blank" rel="noopener noreferrer">Ver Manual</a>
                  </div>
                </Col>
              </Row>
              <Row className="pt-4 pb-4">
                <Col sm={6}>
                  <h5>Gestión de Autorización Swiss Medical</h5>
                  <div className="mb-4 font-weight-bold">
                    <a
                      href="/pdf/manual_swiss_2023.pdf"
                      target="_blank"
                      rel="noopener noreferrer">Ver Manual</a>
                  </div>
                </Col>
                <Col sm={6}>
                  <h5>Gestión de Autorización Swiss Medical (Discapacidad)</h5>
                  <div className="mb-4 font-weight-bold">
                    <a
                      href="/pdf/manual_swiss_discapacidad.pdf"
                      target="_blank"
                      rel="noopener noreferrer">Ver Manual</a>
                  </div>
                </Col>
              </Row>
              <Row className="pt-4 pb-4">
                <Col sm={6}>
                  <h5>Gestión de Autorización Sancor Salud</h5>
                  <div className="mb-4 font-weight-bold">
                    <a
                      href="/pdf/manual_sancor_token.pdf"
                      target="_blank"
                      rel="noopener noreferrer">Ver Manual</a>
                  </div>
                </Col>
                <Col sm={6}>
                  <h5>Gestión de Autorización Federada Salud</h5>
                  <div className="mb-4 font-weight-bold">
                    <a
                      href="/pdf/manual_Federada Salud.pdf"
                      target="_blank"
                      rel="noopener noreferrer">Ver Manual</a>
                  </div>
                </Col>
              </Row>
              <Row className="pt-4 pb-4">
                <Col sm={6}>
                  <h5>Gestión de Autorización AMFFA</h5>
                  <div className="mb-4 font-weight-bold">
                    <a
                      href="/pdf/Manual amffa.pdf"
                      target="_blank"
                      rel="noopener noreferrer">Ver Manual</a>
                  </div>
                </Col>
                <Col sm={6}>
                  <h5>Gestión de Autorización AMFFA (Discapacidad)</h5>
                  <div className="mb-4 font-weight-bold">
                    <a
                      href="/pdf/Manual-seccion_discapacidad_amffa.pdf"
                      target="_blank"
                      rel="noopener noreferrer">Ver Manual</a>
                  </div>
                </Col>
              </Row>
              <Row className="pt-4 pb-4">
                <Col sm={6}>
                  <h5>Gestión de Autorización OSAM</h5>
                  <div className="mb-4 font-weight-bold">
                    <a
                      href="/pdf/Manual osam.pdf"
                      target="_blank"
                      rel="noopener noreferrer">Ver Manual</a>
                  </div>
                </Col>
                <Col sm={6}>
                  <h5>Gestión de Autorización Medifé</h5>
                  <div className="mb-4 font-weight-bold">
                    <a
                      href="/pdf/Cupo Medife.pdf"
                      target="_blank"
                      rel="noopener noreferrer">Ver Manual</a>
                  </div>
                </Col>
              </Row>
              <Row className="pt-4 pb-4">
                <Col sm={6}>
                  <h5>Gestión de Autorización Comei</h5>
                  <div className="mb-4 font-weight-bold">
                    <a
                      href="/pdf/Manual Comei.pdf"
                      target="_blank"
                      rel="noopener noreferrer">Ver Manual</a>
                  </div>
                </Col>
                <Col sm={6}>
                  <h5>Gestión de Autorización Escribanos</h5>
                  <div className="mb-4 font-weight-bold">
                    <a
                      href="/pdf/Manual-Escribanos.pdf"
                      target="_blank"
                      rel="noopener noreferrer">Ver Manual</a>
                  </div>
                </Col>
              </Row>
              <Row className="pt-4 pb-4">
                <Col sm={6}>
                  <h5>Gestión de Autorización Unión Personal</h5>
                  <div className="mb-4 font-weight-bold">
                    <a
                      href="/pdf/Manual UP.pdf"
                      target="_blank"
                      rel="noopener noreferrer">Ver Manual</a>
                  </div>
                </Col>
                <Col sm={6}>
                  <h5>Gestión de Autorización Segunda ART</h5>
                  <div className="mb-4 font-weight-bold">
                    <a
                      href="/pdf/manual_Segunda ART.pdf"
                      target="_blank"
                      rel="noopener noreferrer">Ver Manual</a>
                  </div>
                </Col>
              </Row>
              <Row className="pt-4 pb-4">
                <Col sm={6}>
                  <h5>Gestión de Autorización Amsterdam</h5>
                  <div className="mb-4 font-weight-bold">
                    <a
                      href="/pdf/manual_amsterdam.pdf"
                      target="_blank"
                      rel="noopener noreferrer">Ver Manual</a>
                  </div>
                </Col>
                <Col sm={6}>
                  <h5>Gestión de Autorización Omint</h5>
                  <div className="mb-4 font-weight-bold">
                    <a
                      href="/pdf/manual_omint.pdf"
                      target="_blank"
                      rel="noopener noreferrer">Ver Manual</a>
                  </div>
                </Col>
              </Row>
              <Row className="pt-4 pb-4">
                <Col sm={6}>
                  <h5>Gestión de Autorización Swiss ART</h5>
                  <div className="mb-4 font-weight-bold">
                    <a
                      href="/pdf/manual_swiss_art.pdf"
                      target="_blank"
                      rel="noopener noreferrer">Ver Manual</a>
                  </div>
                </Col>
                <Col sm={6}>
                  <h5>Gestión de Autorización Galeno y Galeno DAN</h5>
                  <div className="mb-4 font-weight-bold">
                    <a
                      href="/pdf/manual_Gleno_y_Galeno_DAN.pdf"
                      target="_blank"
                      rel="noopener noreferrer">Ver Manual</a>
                  </div>
                </Col>
              </Row>
              <Row className="pt-4 pb-4">
                <Col sm={6}>
                  <h5>Gestión de Autorización AMEBPBA</h5>
                  <div className="mb-4 font-weight-bold">
                    <a
                      href="/pdf/manual_amebpba.pdf"
                      target="_blank"
                      rel="noopener noreferrer">Ver Manual</a>
                  </div>
                </Col>
              </Row>
              <Row className="pt-4 pb-4">
                <Col sm={6}>
                  <h5>Gestión de Autorización y Facturación Online</h5>
                  <div className="mb-4 font-weight-bold">
                    <a
                      href="/pdf/manual_Gestión de Autorización y Facturación online.pdf"
                      target="_blank"
                      rel="noopener noreferrer">Ver Manual</a>
                  </div>
                  <YouTubeEmbed embedId="2fEBFY9ZKbs" />
                </Col>
                <Col sm={6}>
                  <h5>APP de Escaneo en dispositivo Móvil</h5>
                  <div className="mb-4 font-weight-bold">
                    <a
                      href="/pdf/app.doc"
                      target="_blank"
                      rel="noopener noreferrer">Ver Manual</a>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Autorizaciones;
